import { render } from "./FormManterHorarioAtendimento.vue?vue&type=template&id=36c947de"
import script from "./FormManterHorarioAtendimento.vue?vue&type=script&lang=js"
export * from "./FormManterHorarioAtendimento.vue?vue&type=script&lang=js"

import "./FormManterHorarioAtendimento.vue?vue&type=style&index=0&id=36c947de&lang=css"
/* custom blocks */
import block0 from "./FormManterHorarioAtendimento.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__